import {externalBaseApi, extractData} from "../../api/axiosConfig";


export const getAllInterests = () =>
    externalBaseApi
        .get("/interest")
        .then(extractData);

export const addInterest = data =>
    externalBaseApi
        .post("/interest", data)
        .then(extractData);

export const editInterest = (interestId, data) =>
    externalBaseApi
        .put(`/interest/${interestId}`, data)
        .then(extractData);

export const deleteInterest = interestId =>
    externalBaseApi
        .delete(`/interest/${interestId}`)
        .then(extractData);

export const getInterestObligationData = cdpvId =>
    externalBaseApi
        .get("/interest/obligationData", {
            params: {
                my_cdpv_id: cdpvId
            }
        })
        .then(extractData);

export const uploadInterest = interest =>
    externalBaseApi
        .post("/interest/upload", interest)
        .then(extractData);

export const getSources = () =>
    externalBaseApi
        .get("/interest/source")
        .then(extractData);

export const interestSearch = request =>
    externalBaseApi
        .post("/interest/interestSearch", request)
        .then(extractData);

// import fetch from 'unfetch';
// import axios from "axios";
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
// const checkStatus = response => {
//     if (response.ok) {
//         return response;
//     }
// // convert non-2xx HTTP responses into errors:
//     const error = new Error(response.statusText);
//     error.response = response;
//     return Promise.reject(error);
// }
//
// export const getAllInterests = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/interest`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addInterest = abcd =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/interest`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const editInterest = (selectorInterestId, data) =>
//     axios.put(`${BASE_URL}/ExternalData/api/contramatic/interest/${selectorInterestId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteInterest = interestId =>
//     axios.delete(`${BASE_URL}/ExternalData/api/contramatic/interest/${interestId}`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getInterestObligationData = (my_cdpv_id) =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/interest/obligationData`,
//         {
//             headers: {
//                 'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//             },
//             params: {my_cdpv_id: my_cdpv_id}
//         })
//         // export const executeExpression = (id) =>
//         //     axios.get(`${BASE_URL}/api/contramatic/contractDataPoint/expression/${id}`)
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const uploadInterest = (interest) =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/interest/upload`,interest, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getSources = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/interest/source`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const interestSearch = (request) =>
//
//     axios.post(
//         `${BASE_URL}/ExternalData/api/contramatic/interest/interestSearch`,
//         request,
//         // CONFIG
//         {
//             headers: {
//                 Authorization:
//                     'Bearer ' + localStorage.getItem('token'),
//                 'Content-Type': 'application/json'
//             }
//         }
//     )
//
//         .catch(function (error) {
//
//             if (error.response) {
//
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//
//             } else if (error.request) {
//
//                 console.log(error.request);
//
//             } else {
//
//                 console.log('Error', error.message);
//
//             }
//
//             console.log(error.config);
//
//         });